
export default {
    zh:{
        title: '品评报告模板',
        serialNo:'模板编号',
        status:"提交状态",
        name:'模板名称',
        createNew:'新增品评报告模板',
        templateDetail:'模板明细',
        productDetail:'模板产品明细',
        selectAuditor:'模板审批人选择器',
        copy: '复制',
        addTemplate:'品评报告模板维护',
        SensoryReporttemplateNo:'Sensory报告模板编号',
        createTime:'创建时间',
        createBy:'创建人',
        remarks:'备注',
        productNumber:'产品编号',
        productName:'产品名称',
        productTemplateVersionNumber:'产品模板版本号',
        isEffective:'是否有效',
        detailName:'名称',
        criterion:'标准',
        PleaseMaintainDetailLine:'请维护明细行',
        modules:'模块',
    },
    en:{
        title: 'Sensory Template',
        serialNo:'Template No.',
        status:"Submit Status",
        name:'Template Name',
        createNew:'Create New Template',
        selectAuditor:'Select Auditor',
        copy: 'Copy',
        addTemplate:'Maintenance of evaluation report template',
        SensoryReporttemplateNo:'Sensory Report template No',
        createTime:'Create Time',
        createBy:'Create By',
        remarks:'Remarks',
        productNumber:'Product number',
        productName:'Product Name',
        productTemplateVersionNumber:'Product template version number',
        isEffective:'Is it effective',
        detailName:'Name',
        criterion:'Criterion',
        PleaseMaintainDetailLine:'Please maintain detail line',
        modules:'Modules',
    }
}
